import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonGroup } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import DashboardMetricsApi from '../../apis/DashboardMetrices';
import BenchmarkMetrices from './metrics-list/BenchmarkMetrics';
import ValueMetrics from './metrics-list/ValueMetrics';

const defaultMetricsData = {
  value: {
    type: 'total',
    time_range: 'daily'
  },
  benchmark: {
    type: 'total_change',
    time_range: 'daily',
    goal: 0,
  }
}

class ConfigureModal extends Component {
  constructor() {
    super();
    this.state = {
      configData: defaultMetricsData,
      goalError: '',
    };
  }

  componentDidMount() {
    this.fetchComponentConfig();
  }

  componentDidUpdate = (prevProps) => {
    const { isVisible } = this.props;

    if (isVisible && !prevProps.isVisible)
      this.fetchComponentConfig();
  }

  fetchComponentConfig = () => {
    const { editComponentId } = this.props;

    if (editComponentId)
      DashboardMetricsApi.getDetails(editComponentId).then(({ data }) => {
        if (typeof data == 'string')
          return this.setState({ configData: {} });
        this.setState({ configData: data.config_data })
        return;
      })
    else
      this.setState({ configData: defaultMetricsData });
  }

  handleBenchMarkChanged = (benchmarkType) => {
    const { configData: { value, benchmark } } = this.state;
    const newBenchmark = { ...benchmark, type: benchmarkType };
    const newConfigData = { value, benchmark: newBenchmark };

    this.setState({ configData: newConfigData });
  }

  validateGoalValue = (value) => {
    const pattern = /^\d+$/gm;
    const result = pattern.test(value);

    if (!result)
      this.setState({ goalError: 'Please enter Valid Value' });

    return result;
  }

  handleConfigDataChange = (configType, subType, value) => {
    const goalError = "";
    const { configData } = this.state;
    const _configData = { ...configData };
    _configData[configType][subType] = value;
    const data = { ...configData, ..._configData };

    this.setState({ configData: data, goalError });
  }

  handleSave = (e) => {
    e.preventDefault();
    const { configData } = this.state;
    const { editComponentId, addNewMetric, saveMetricConfig, configModalTitle } = this.props;
    const metricData = { metric: configModalTitle, ...configData };
    const { type, goal } = configData.benchmark;

    if (type == 'goal' && !this.validateGoalValue(goal))
      return;

    if (editComponentId) saveMetricConfig(metricData)
    else addNewMetric(metricData)
  }

  removeConfig = () => {
    this.props.toggleRemoveConfigModal(this.props.editComponentId);
  }

  render() {
    const { isVisible, toggleModal, editComponentId, configModalTitle } = this.props;
    const { configData, goalError } = this.state;
    const { value, benchmark } = configData;
    const buttonText = editComponentId ? 'Save Component' : 'Add Component';

    return (
      <Modal className="select-metrics-modal" isOpen={isVisible} toggle={toggleModal}>
        <ModalHeader>
          <div className="metric-title">
            <div className="metric-action d-inline">
              <FontAwesomeIcon icon="calculator" />
            </div>
            Configure - {configModalTitle}
          </div>
        </ModalHeader>
        <ModalBody>
          <ValueMetrics configValue={value} handleConfigDataChange={this.handleConfigDataChange} />
          <BenchmarkMetrices goalError={goalError} benchmark={benchmark} handleBenchMarkChanged={this.handleBenchMarkChanged} handleConfigDataChange={this.handleConfigDataChange} />
        </ModalBody>
        <ModalFooter className="d-block">
          {
            editComponentId && <Button className="btn-remove mt-2" onClick={this.removeConfig}>
              <span className="ml-2">
                <FontAwesomeIcon icon="times-circle" />
              </span>
              Remove
            </Button>
          }
          <ButtonGroup className="float-right">
            <Button className="btn-cancel" onClick={toggleModal}>Cancel</Button>
            <Button className="btn-add" onClick={this.handleSave}>{buttonText}</Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    );
  }
};

ConfigureModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  editComponentId: PropTypes.string,
  configModalTitle: PropTypes.string,
};

ConfigureModal.defaultProps = {
  editComponentId: undefined,
  configModalTitle: undefined,
};

export default ConfigureModal;



// WEBPACK FOOTER //
// ./src/components/dashboard/ConfigureModal.js